import { isValidDateRange } from '@shared/utils/dateRange';
import { isEqual, startOfMinute } from 'date-fns';
import type { DateRange, Preset, PresetCreateContext } from '../types';

interface GetActivePresetOptions<T extends Preset> extends PresetCreateContext {
  presets: readonly T[];
}

export function getActivePreset<T extends Preset>(
  dateRange: DateRange,
  options: GetActivePresetOptions<T>
) {
  if (!isValidDateRange(dateRange)) {
    return;
  }

  const range = {
    from: startOfMinute(dateRange.from),
    to: startOfMinute(dateRange.to),
  };

  return options.presets.find((preset) => {
    const { from, to } = preset.createRange(options);

    return (
      isEqual(range.from, startOfMinute(from)) &&
      isEqual(range.to, startOfMinute(to))
    );
  });
}
